
import ar from './ar/common';
import zh from './zh/common';
import arCourses from './ar/courses';
import enCourses from './en/courses';
import zhCourses from './zh/courses';
import arApplication from './ar/application';
import enApplication from './en/application';
import zhApplication from './zh/application';
import arSmartSchool from './ar/smartSchool';
import enSmartSchool from './en/smartSchool';
import zhSmartSchool from './zh/smartSchool';

const messages = {
  ar: {
    translation: ar,
    courses: arCourses,
    application: arApplication,
    smartSchool: arSmartSchool,
  },
  en: {
    courses: enCourses,
    application: enApplication,
    smartSchool: enSmartSchool,
  },
  zh: {
    translation: zh,
    courses: zhCourses,
    application: zhApplication,
    smartSchool: zhSmartSchool,
  },
};

export default messages;
